const POLL_INTERVAL_MS = 30
const DEFAULT_TIMEOUT_MS = 30_000

/**
 * Attend que `condition` soit vraie en la testant périodiquement.
 * Rejette si elle n'est pas vérifiée avant `timeoutMs`, pour ne pas laisser un timer tourner indéfiniment
 * (ex. script de consentement jamais chargé en local/recette).
 */
export const waitFor = (condition: () => boolean, timeoutMs = DEFAULT_TIMEOUT_MS): Promise<void> =>
  new Promise((resolve, reject) => {
    const startedAt = Date.now()

    const check = () => {
      if (condition()) resolve()
      else if (Date.now() - startedAt >= timeoutMs) reject(new Error('waitFor: timeout'))
      else setTimeout(check, POLL_INTERVAL_MS)
    }

    check()
  })
